//首页接口
import axios from '../common/js/axios'
import { host } from '../common/js/config'

/*示例*/ 
export function getHomeData(data) {
	const url = `${host}/app/valueadded/courseinfo`
	return axios({
		url: url,
		params: data
	})
}

/*我的订单*/

export function getVipOrder(data){
	const url = `${host}/app/order/list`
	return axios({
		url: url,
		params: data
	})
}

/*取消订单*/

export function cancelVipOrder(data){
	const url = `${host}/app/order/cancel`
	return axios({
		url: url,
		params: data
	})
}


/*生成订单*/
export function createOrder(data){
	const url = `${host}/app/order/buyPayCourse`
	return axios({
		url: url,
		params: data
	})
}

/** h5支付 */
export function payOrder(data){
	const url = `${host}/app/h5/order/payOrder`
	return axios({
		url: url,
		params: data
	})
}


/*微信 支付*/
export function getOrderWeix(data){
	const url = `${host}/app/order/params`
	return axios({
		url: url,
		params: data
	})
}

/* 微信jsapi */
export function isWeixOrder(data){
	const url = `${host}/app/jsapi/order/payOrder`
	return axios({
		url: url,
		params: data
	})
}

/* 订单详情 */
export function orderDetial(data){
	const url = `${host}/app/order/detail`
	return axios({
		url: url,
		params: data
	})
}

/** 确认收货 */
export function confirmGeTGood(data){
	const url = `${host}/app/order/receive`
	return axios({
		url: url,
		params: data
	})
}

/** 物流信息 */
export function getOrderSendMessage(data){
	const url = `${host}/app/order/getOrderSendMessage`
	return axios({
		url: url,
		params: data
	})
}


// WEBPACK FOOTER //
// ./src/api/pay.js